import AdminDuplicatePhotosScreen from '../../src/screens/AdminDuplicatePhotosScreen';

export default function AdminDuplicatePhotosRoute() {
  return <AdminDuplicatePhotosScreen />;
}
